var shared = require('./_shared')('keys')
  , uid    = require('./_uid');
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/modules/_shared-key.js
// module id = 182
// module chunks = 48 49 50 51